<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <component :is="cardType" class="image-card" v-bind="{ ...propTypes}">
      <cloudinary-image
        aspect-ratio="1/1"
        :image-alt="imageAlt"
        :image-source="imageSrc"
      />

      <heading class="title" :tagField="innerHeadingSize" :textField="venueName"/>

      <div class="subtitle">{{location}}</div>

      <div class="description">{{description}}</div>
    </component>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import ShLink from '~/components/sh-link'
import CloudinaryImage from '~/components/cloudinary-image'
import get from '~/helpers/get'

import ScRender from '../sc-render'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'AutomatedContentListTile',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },

    innerHeadingSize: {
      type: Object,
      required: true
    }
  },

  components: {
    ScRender,
    CloudinaryImage,
    Heading,
    ShLink
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    imageFields () {
      return get(this.fields, 'houseImage')
    },

    imageAlt () {
      return get(this.imageFields, 'value.alt')
    },

    imageSrc () {
      return get(this.imageFields, 'value.src')
    },

    venueName () {
      return get(this.fields, 'venueName')
    },

    location () {
      return get(this.fields, 'location.value')
    },

    description () {
      return get(this.fields, 'description.value')
    },

    linkHref () {
      return get(this.fields, 'link.value.href')
    },

    linkTarget () {
      return get(this.fields, 'link.value.linktarget', '')
    },

    cardType () {
      if (!this.linkHref) return 'div'

      return 'sh-link'
    },

    propTypes () {
      if (this.cardType === 'div') {
        return { tabindex: '0' }
      }

      return {
        to: this.linkHref,
        target: this.linkTarget
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-card {
  display: flex;
  flex-direction: column;
  padding: 0 $space-020;
  width: 265px;
  flex-shrink: 0;
  text-decoration: none;

  @include tablet {
    width: 25%;
    max-width: 600px;
    flex-shrink: 1;
    margin-bottom: $space-090;
  }

  .title {
    @include font('070');
    margin-top: $space-040;
    margin-bottom: $space-020;
  }
}

.subtitle {
  @include font('040');
  margin-bottom: $space-020;
}

.description {
  @include font('040');
  color: $color_gray;
}
</style>
